<template>
  <b-modal ref="CreditNoteCompensationModal" @shown="shown"
           :no-close-on-backdrop="true" :no-enforce-focus="true">
    <div slot="modal-title">
      <div class="d-flex">
        <h5 class="modal-title">
          {{$t('dialogs.create_credit_note_compensation')}}
        </h5>
      </div>
    </div>
    <div>
      <b-row>
        <b-col>
          <label>{{$t('labels.invoice.credit_invoice')}}</label>
          <multiselect v-model="selectedData.credit_invoice" :max-height="200"
                       label="invoice_number" track-by="id"
                       :class="{required: !selectedData.credit_invoice}"
                       :options="creditInvoices" :multiple="false"
                       :close-on-select="true"/>
        </b-col>
      </b-row>
    </div>
    <div slot="modal-footer" class="w-100 d-flex justify-content-center align-items-center">
      <b-btn size="sm" class="ml-2" variant="success" @click="createInvoice"
             :disabled="!selectedData.credit_invoice"
             title="Create invoice">
        {{$t('buttons.common.create')}}
      </b-btn>
    </div>
  </b-modal>
</template>

<script>
  import Multiselect from 'vue-multiselect';
  import { handlerResponse } from '@/helpers/commonHelpers';
  import { notificationsRenderer } from '@/helpers/renderHelpers';
  import { COMPENSATION, CREDIT } from '@/constants/invoiceTypes';

  export default {
    props: ['invoice'],
    components: {
      Multiselect
    },
    data() {
      return {
        selectedData: {
          credit_invoice: null
        }
      }
    },
    computed: {
      creditInvoices() {
        return this.invoice.related_invoices && this.invoice.related_invoices.length
          && this.invoice.related_invoices.filter(invoice =>
            invoice.type === CREDIT && !invoice.auto_created_invoice && !invoice.related_compensation_exists) || [];
      }
    },
    methods: {
      shown() {
        this.selectedData = {
          credit_invoice: null
        }
      },
      prepareInvoiceData() {
        return {
          buyer: this.invoice.buyer.id,
          final_invoice: this.selectedData.credit_invoice && this.selectedData.credit_invoice.id,
          initial_invoice: this.invoice.id,
          invoice_date: this.invoice.invoice_date,
          seller: this.invoice.seller.id,
          type: COMPENSATION,
          auto_created: false
        }
      },
      createInvoice() {
        const invoiceData = this.prepareInvoiceData();
        this.$http.post('accounting/invoices/', invoiceData).then(handlerResponse).then((response) => {
          this.$refs['CreditNoteCompensationModal'].hide();
          this.$router.push({path: `/sales-invoice/${response.id}`});
        }).catch(error => notificationsRenderer(error.data, 'error'));
      }
    },
    mounted() {
      this.$root.$on('openCreditNoteCompensationModal', _ => {
        if (this.$refs['CreditNoteCompensationModal']) {
          this.$refs['CreditNoteCompensationModal'].show();
        }
      });
    },
    beforeDestroy() {
      this.$root.$off('openCreditNoteCompensationModal');
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/modals/CreditNoteCompensationModal.vue